export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 Web Developer. All rights reserved. | <a href="#" className="hover:text-white transition-colors cursor-pointer">Website developer</a></p>
        </div>
      </div>
    </footer>
  );
}